// Maybe move this to common-fe?
export enum LoginSignUpOrigins {
  cart = "cart",
  checkout = "checkout",
}
